import isMatched from '../isMatched';
import type { ScannerGroup } from '../../DxfArrayScanner';
import type DxfArrayScanner from '../../DxfArrayScanner';
import parsePoint from '../parsePoint';
import { DXFParserSnippet } from '../parserGenerator';
import type { XData, XDataEntry } from './types';

function getType(code: number) {
    switch (code) {
        case 1000:
        case 1003:
        case 1005:
            return 'string';
        case 1004:
            return 'hex';
        case 1040:
        case 1041:
        case 1042:
            return 'real';
        case 1070:
            return 'integer';
        case 1071:
            return 'long';
        case 1010:
        case 1011:
        case 1012:
        case 1013:
            return 'point';
        default:
            return '';
    }
}

export function parseXData(curr: ScannerGroup, scanner: DxfArrayScanner) {
    if (!isMatched(curr, 1001)) {
        throw new Error('XData must starts with code 1001');
    }

    const xdata: XData = {
        appName: curr.value,
        value: [] as XDataEntry[],
    };

    let current = curr;
    current = scanner.next();

    const stack = [xdata.value] as any[][];

    while (!isMatched(current, 0, 'EOF') && current.code >= 1000) {
        const top = stack.at(-1)!;

        switch (current.code) {
            case 1002:
                if (current.value === '{') {
                    stack.push([]);
                } else {
                    stack.pop();
                    stack.at(-1)?.push(top);
                }
                break;
            case 1000: // string
            case 1004: // hex string
            case 1040: // real
            case 1070: // integer
            case 1071: // long
                top.push({
                    type: getType(current.code),
                    value: current.value,
                });
                break;
            case 1003:
                top.push({
                    name: 'layer',
                    type: getType(current.code),
                    value: current.value,
                });
                break;
            case 1005:
                top.push({
                    name: 'handle',
                    type: getType(current.code),
                    value: current.value,
                });
                break;
            case 1010: // just 3 reals
                top.push({
                    type: getType(current.code),
                    value: parsePoint(scanner),
                });
                break;
            case 1011:
                top.push({
                    name: 'worldSpacePosition',
                    type: getType(current.code),
                    value: parsePoint(scanner),
                });
                break;
            case 1012:
                top.push({
                    name: 'worldSpaceDisplacement',
                    type: getType(current.code),
                    value: parsePoint(scanner),
                });
                break;
            case 1013:
                top.push({
                    name: 'worldSpaceDirection',
                    type: getType(current.code),
                    value: parsePoint(scanner),
                });
                break;
            case 1041:
                top.push({
                    name: 'distance',
                    type: getType(current.code),
                    value: current.value,
                });
                break;
            case 1042:
                top.push({
                    name: 'scale',
                    type: getType(current.code),
                    value: current.value,
                });
                break;

            default:
                break;
        }

        current = scanner.next();
    }

    scanner.rewind();
    return xdata;
}

export const XDataParserSnippets: DXFParserSnippet[] = [
    {
        code: 1001,
        name: 'xdata',
        parser: parseXData,
    },
];
